import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Pages/Login';
import Dashboard from './Pages/Dashboard';
import DecisionSupport from './Pages/DecisionSupport';
import GestionUsers from './Pages/GestionUsers';
import NotFound from './Pages/NotFound';
import { AuthProvider } from './Context/AuthContext';
import ProtectedRoute from './Components/ProtectedRoute';
import Layout from './Components/Layout';
import Tarification from './Layout/Transport/Tarification';
import Voyages from './Layout/Transport/Voyages';
import Chauffeurs from './Layout/Transport/Chauffeurs';
import Vehicules from './Layout/Transport/Vehicules';
import TestPage from './Pages/testing';
import NotAuthorized from './Pages/NotAuthorized';
import Profile from './Pages/Profile';
import Clients from './Layout/Clients/Clients';
import Carburant from './Layout/Carburant';
import ComingSoon from './Pages/isComing';
import FacturesList from './Layout/Factures/FacturesList';
import FactureView from './Layout/Factures/FactureView';
import FactureForm from './Layout/Factures/FactureForm';
import StockScelles from './Layout/Logistique/StockScelles';
import DocumentManagement from './Layout/Documents/DocumentManagement';
import DocumentAlerts from './Layout/Documents/DocumentAlerts';
import DocumentStatistics from './Layout/Documents/DocumentStatistics';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageTitleManager from "./Components/PageTitleManager";

/// rowsSelected.length === 1 ? (  

/// <Typography variant="h4" sx={{ fontSize: '20px', color: '#1D3E62', textAlign: 'center', fontWeight: 600, p: '20px' }}>
         //     Une seule ligne peut être modifiée à la fois.
           // </Typography>

const APP_ZOOM = 0.94;

const theme = createTheme({
  typography: { fontFamily: 'Montserrat, sans-serif' },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        'html, body, #root': {
          zoom: APP_ZOOM,                // Chromium browsers
          margin: 0,
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          height: '100%',
          minHeight: '100%',
        },
        // Firefox fallback (no native zoom support)
        '@supports not (zoom: 1)': {
          'html, body, #root': {
            transform: `scale(${APP_ZOOM})`,
            transformOrigin: 'top left',
            width: `${100 / APP_ZOOM}%`,
            height: `${100 / APP_ZOOM}%`,
            overflowX: 'hidden',
          },
        },
      },
    },
  },
});

function App() {
  return (
    <Router>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <PageTitleManager />
          <ToastContainer position="top-right" theme="colored" autoClose={5000} />
          <CssBaseline />
          <Routes>
            
            {/* Public */}
            <Route path="/" element={<Login />} />
            {/* <Route path="/testing" element={<TestPage />} /> */}
            <Route path="/NotAuthorized" element={<NotAuthorized />} />
            <Route path="/isComing" element={<ComingSoon />} />

            {/* Super admin only (add pages if needed) */}
            <Route element={<ProtectedRoute roles={['super_admin']} />}></Route>

            {/* Shared protected */}
            <Route element={<ProtectedRoute roles={['admin','user','user-facture','super_admin']} />}>
              <Route path="/Dashboard" element={<Layout><Dashboard /></Layout>} />
              <Route path="/decision-support" element={<Layout><DecisionSupport /></Layout>} />
              <Route path="/Profile" element={<Layout><Profile /></Layout>} />
              <Route path="/Gestion-des-utilisateurs" element={<Layout><GestionUsers /></Layout>} />
            </Route>

            {/* Transport + Factures + Logistique */}
            <Route element={<ProtectedRoute roles={['admin','user-facture','super_admin','user']} />}>
              <Route path="/Transport/Tarification" element={<Layout><Tarification /></Layout>} />
              <Route path="/Transport/Voyages" element={<Layout><Voyages /></Layout>} />
              <Route path="/Transport/Chauffeurs" element={<Layout><Chauffeurs /></Layout>} />
              <Route path="/Transport/Vehicules" element={<Layout><Vehicules /></Layout>} />
              <Route path="/Clients/ListClients" element={<Layout><Clients /></Layout>} />
              <Route path="/Carburants" element={<Layout><Carburant /></Layout>} />
              <Route path="/Logistique/Stock-scellés" element={<Layout><StockScelles /></Layout>} />

              <Route path="/factures" element={<Layout><FacturesList /></Layout>} />
              <Route path="/factures/view/:id" element={<Layout><FactureView /></Layout>} />
              <Route path="/factures/create" element={<Layout><FactureForm /></Layout>} />
              <Route path="/factures/edit/:id" element={<Layout><FactureForm /></Layout>} />
              
              {/* Documents */}
              <Route path="/Documents/Management" element={<Layout><DocumentManagement /></Layout>} />
              <Route path="/Documents/Alerts" element={<Layout><DocumentAlerts /></Layout>} />
              <Route path="/Documents/Statistics" element={<Layout><DocumentStatistics /></Layout>} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
